import { t } from "i18next";
import { validateRequired } from "../../EquipmentList/equipmentlist.functions";
import { validateNameWithOptionalDescription } from "../../../utils/validate-name-description-row";
import { FleetManagementRowValues } from "../types/FleetManagement-row.types";

type Errors = Record<string, string>;

function toStr(value: unknown): string {
  if (value === undefined || value === null) {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }

  return "";
}

function validateRequiredField(value: unknown, message: string): string {
  return validateRequired(toStr(value)) ? "" : t(message);
}

export function validatePositiveNumber(
  value: unknown,
  emptyMessage: string,
  invalidMessage: string
): string {
  const str = toStr(value);

  if (!validateRequired(str)) {
    return t(emptyMessage);
  }

  if (Number(str) <= 0) {
    return t(invalidMessage);
  }

  return "";
}

export function validateOptionalPositiveNumber(value: unknown, invalidMessage: string): string {
  const str = toStr(value);

  if (!str) {
    return "";
  }

  return Number(str) <= 0 ? t(invalidMessage) : "";
}

/**
 * Validates a fleet table row before create/update.
 */
export function validateFleetTableRow(row: Partial<FleetManagementRowValues>): Errors {
  const base = validateNameWithOptionalDescription({
    name: row.name,
    description: row.description
  });

  return {
    ...base,

    licensePlate: validateRequiredField(row.licensePlate, "License plate cannot be empty"),

    brandModel: validateRequiredField(row.brandModel, "Brand model cannot be empty"),

    numSeats: validatePositiveNumber(
      row.numSeats,
      "Number of seats cannot be empty",
      "Number of seats must be greater than 0"
    ),

    fuel: validateRequiredField(row.fuel, "Fuel cannot be empty"),

    odometer: validatePositiveNumber(
      row.odometer,
      "Odometer cannot be empty",
      "Odometer must be greater than 0"
    ),

    reach: validateOptionalPositiveNumber(row.reach, "Reach must be greater than 0"),

    companyId: validateRequiredField(row.companyId, "Company cannot be empty")
  };
}
